export const articleService: Record<string, string> = {
 'choosing-your-first-workflow': 'business-process-automation',
 'accounting-finance-automation': 'ai-automation', 'key-benefits-of-ai-2025': 'ai-automation',
 'when-not-to-use-ai': 'workflow-automation', 'ethics-of-ai-automation': 'ai-automation',
 'openai-api': 'ai-automation', 'invoice-extraction-three-model-test': 'ai-automation',
 'thai-sme-line-ai-readiness': 'ai-automation', 'notion-api': 'custom-software',
 'airtable-token': 'custom-software', 'ai-agents-vs-workflow-automation': 'ai-automation',
};
export const relatedArticles: Record<string, string[]> = {
 'choosing-your-first-workflow': ['when-not-to-use-ai', 'n8n-api-connection-failure'],
 'key-benefits-of-ai-2025': ['when-not-to-use-ai', 'ai-agents-vs-workflow-automation'],
 'accounting-finance-automation': ['invoice-extraction-three-model-test', 'ethics-of-ai-automation', 'n8n-api-connection-failure'],
 'ethics-of-ai-automation': ['accounting-finance-automation', 'ai-agents-vs-workflow-automation'],
 'google-calendar-credentials': ['n8n-api-connection-failure', 'thai-sme-line-ai-readiness'],
 'slack-oauth': ['ethics-of-ai-automation', 'n8n-api-connection-failure'],
 'dropbox-api': ['accounting-finance-automation', 'n8n-api-connection-failure'],
 'twilio': ['whatsapp-crm-singapore-sme', 'n8n-api-connection-failure'],
 'sendgrid': ['n8n-api-connection-failure', 'hubspot-api'],
 'telegram-bot': ['slack-oauth', 'ethics-of-ai-automation'],
 'whatsapp': ['whatsapp-crm-singapore-sme', 'thai-sme-line-ai-readiness'],
 'hubspot-api': ['whatsapp-crm-singapore-sme', 'n8n-api-connection-failure'],
 'notion-api': ['airtable-token', 'choosing-your-first-workflow'],
 'airtable-token': ['notion-api', 'n8n-api-connection-failure'],
 'stripe-api': ['n8n-api-connection-failure', 'ethics-of-ai-automation'],
 'openai-api': ['ai-agents-vs-workflow-automation', 'invoice-extraction-three-model-test'],
};
